<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <template v-slot:title>Copy Linked Services</template>
    <v-row>
      <v-col>
        <v-select
          v-model="selectedServiceIds"
          :items="serviceItems"
          label="Copy to"
          item-text="name"
          item-value="id"
          multiple
          :outlined="outlinedInputs"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <pre>{{ serviceItems }}</pre>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onSave">Copy</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import { removeGQLTypename } from "../../../../helpers";
import BasicDialog from "../../shared/BasicDialog.vue";
export default {
  name: "clone-linked-services",

  props: {
    show: {
      type: Boolean,
      default: () => true,
    },
    services: {
      type: Array,
      default: () => [],
    },
  },
  components: { BasicDialog },

  data() {
    return {
      debug: false,
      selectedServiceIds: [],
    };
  },
  computed: {
    serviceItems() {
      return this.services.map(removeGQLTypename);
    },
    isValid() {
      return this.selectedServiceIds.length > 0;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },
  methods: {
    onSave() {
      this.$emit("save", this.selectedServiceIds);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/suppliers/linked-services/CloneLinkedServices.vue